module.exports = __webpack_public_path__ + "static/media/anim.128dc9c9.gif";